import { Component } from '@angular/core';
import { combineLatest, filter, map, Observable } from 'rxjs';
import { MatTableDataSource } from '@angular/material/table';
import { BaseComponent } from '../../../base.component';
import { distinctUntilChanged } from 'rxjs/operators';
import { ComparisonUtility } from '@utilities/comparison.utility';
import { ProcessingManager } from '@managers/processing.manager';
import { ProcessingStep } from '@models/ui/processing-step.model';
import { orderBy } from 'lodash-es';
import { rowTransitionAnimation } from "../animations";

@Component({
    selector: 'lex-active-steps',
    templateUrl: './active-steps-table.component.html',
    styleUrls: ['./active-steps-table.component.scss'],
    animations: [rowTransitionAnimation],
    standalone: false
})
export class ActiveStepsTableComponent extends BaseComponent {
	public dataSource$: Observable<MatTableDataSource<ProcessingStep>>;
	public rowHeight$ = this.processingManager.currentRowHeight$;

	public columnsToDisplay = [
		'accountName',
		'caseName',
		'functionName',
		'functionCount'
	];

	constructor(public processingManager: ProcessingManager) {
		super();

		this.dataSource$ = combineLatest([
			this.processingManager.activeSteps$,
			this.processingManager.currentFilterText$
		]).pipe(
			filter(([collection]) => !!collection),
			distinctUntilChanged((a, b) => ComparisonUtility.isEqual(a, b)),
			map(([logCollection, term]) => {
				if (term) {
					logCollection = logCollection?.filter((item) => {
						return item.caseName?.toLowerCase().includes(term.toLowerCase()) ||
							item.stepName?.toLowerCase().includes(term.toLowerCase()) ||
							item.accountName?.toLowerCase().includes(term.toLowerCase());
					});
				}
				logCollection = orderBy(logCollection, (item) => item.caseName.toLowerCase(), 'asc');
				return new MatTableDataSource(logCollection as any);
			})
		);
	}

	public trackByFn(index: number, item: any) {
		return `${ item.caseId }:${ item.stepName }:${ item.functionCount }`;
	}

}
